import {HttpModelConverter} from '../../../../../core/converter/httpModel.converter';
import {ValueAndLabelConverter} from '../../../../../common/converter/ValueAndLabel.converter';
import {UserSummary} from '../entity/userSummary.model';
import {LovValueSummaryConverter} from '../../../../../common/lov/lov-value/api/converter/LovValueSummary.converter';
import {Injectable} from '@angular/core';
import {PhoneConverter} from "../../../../../common/phone/entity/converter/phone.converter";

@Injectable({providedIn: 'root'})
export class UserSummaryConverter extends HttpModelConverter<UserSummary> {

    protected createInstance(): UserSummary {
        return new UserSummary();
    }

    protected enrichObject(result: UserSummary, src: UserSummary) {
        result.gender = new ValueAndLabelConverter().convert(src.gender);
        result.role = new LovValueSummaryConverter().convert(src.role);
        result.phone = new PhoneConverter().convert(src.phone);
    }
}
